export default "__VITE_ASSET__BdHinRJQ__"